<template>
  <div class="compose-view" style="margin: 0 auto;" :style="{ maxWidth: width + 'px !important' }">
    <div class="composer mb-6">
      <compose-toolbar />
      <div v-if="activeThread !== null" class="tweets">
        <emoji-picker
            ref="emojipicker"
            :trigger="showEmojiPopup"
            :picker-top="emojiTop"
            :picker-left="emojiLeft"
            @selected="insertEmoji"
            @hide="showEmojiPopup = false; $store.dispatch('focusOnActiveTweet')"
        />
        <reply-to/>
        <draggable
            :force-fallback="true"
            :scroll-sensitivity="100"
            :scroll-speed="25"
            v-model="tweets"
            @end="tweetDragEnded"
            handle=".media-left">
          <tweet-box
              v-for="(tweet, index) in tweets"
              :key="tweet.id"
              :id="tweet.id"
              :index="index"
              :is-first="index === 0 && !$store.getters.replyTo"
              :is-last="index + 1 === tweets.length"
              :ref="'tweet' + tweet.id"
              :has-focus="tweet.hasFocus"
              @showEmojis="showEmojis"
              @showHotkeyModal="showHotkeysModal = true"
              @addTweetBelow="(text) => addTweet(index + 1, text)"
              @insertTextBelow="(text) => insertTextToTweet(index + 1, text)"
              @focusOnFirstError="focusOnFirstError"
          />
        </draggable>
      </div>
      <div class="hotkeys has-text-right">
        <p class="mt-4">
          <b-button type="is-primary is-light" @click.prevent="showHotkeysModal = true"><span>Hotkeys</span>
          </b-button>
        </p>
      </div>
    </div>
    <submit-nav v-if="activeThread !== null" :width="width" />
    <b-modal v-model="showHotkeysModal" has-modal-card trap-focus aria-role="dialog" class="dialog dialog-wide">
      <template><hotkeys-modal></hotkeys-modal></template>
    </b-modal>
  </div>
</template>
<script>

import Draggable from 'vuedraggable'
import ReplyTo from "../../components/compose/ReplyTo"
import TweetBox from '../../components/compose/TweetBox.vue'
import EmojiPicker from "../../components/EmojiPicker";
import HotkeysModal from "../../components/modals/HotkeysModal"
import SubmitNav from "../../components/SubmitNav";
import ComposeToolbar from "../../components/compose/ComposeToolbar";

export default {
  name: 'ComposeSimple',
  components: {
    ComposeToolbar,
    HotkeysModal,
    Draggable,
    ReplyTo,
    SubmitNav,
    TweetBox,
    EmojiPicker
  },

  data() {
    return {
      width: 640,
      showEmojiPopup: false,
      emojiTop: 0,
      emojiLeft: 0,
      triggerSubmit: false,
      showHotkeysModal: false
    }
  },

  computed: {
    activeThread() {
      return this.$store.state.compose.activeThread
    },
    tweets:  {
      get() {
        return this.$store.getters.tweets
      },
      set(val) {
        this.$store.commit('setAllTweets', val)
        this.$store.commit('refreshLastEdit')
      }
    }
  },

  mounted() {
    if (this.activeThread === null) {
      this.$store.dispatch('createNewThread')
    }
  },

  watch: {
    activeThread(val) {
      this.$store.dispatch('focusOnActiveTweet')
    }
  },

  methods: {
    getEditor(id) {
      /* this is a bit of a hack. Each tweetbox exists in a 0 array
      named `tweet[id]`. Vue doesn't update refs so we can't use
      the built in ref array, but we also can't turn it off - so
      they are all 0-based arrays. */
      return this.$refs['tweet' + id][0]
    },

    getEditorFromIndex(index) {
      /* Gets the editor based on index, looking up its ID in the store */
      return this.getEditor(this.tweets[index].id)
    },

    showEmojis() {
      let editarea = this.getEditorFromIndex(this.$store.getters.activeTweetIndex).$refs.editarea.getBoundingClientRect();
      this.emojiTop = editarea.top + editarea.height
      this.emojiLeft = editarea.left
      this.showEmojiPopup = true
    },

    focusOnFirstError() {
      // navigate to tweet with first error
      if (this.$store.getters.tweetThreadErrors.length) {
        this.$store.dispatch(
            'focusOnTweet',
            this.$store.getters.tweetIndexById(this.$store.getters.tweetThreadErrors[0].id)
        )
      }
    },

    insertEmoji(emoji) {
      this.getEditorFromIndex(this.$store.getters.activeTweetIndex).insertAtCursor(emoji.native);
    },

    searchEmojis(search, limit) {
      /* returns an array of objects - e.g.
        id: "smile"
        name: "Smiling Face with Open Mouth and Smiling Eyes"
        colons: ":smile:"
        emoticons: Array [ "=)", "=-)" ... ]
        native: unicode string
        short_name: 'smiley'
        short_names: ['smiley'...]
        unified: (something unicode?) */
      return this.$refs.emojipicker.emojis.search(search, limit)
    },

    addTweet(index, text) {
      this.$store.dispatch('addTweetAndFocus', {index: index, text: text});
    },

    insertTextToTweet(index, text) {
      this.$store.dispatch('insertTextToTweet', {index: index, text: text})
      this.getEditorFromIndex(index).updateErrorStatus()
    },

    tweetDragEnded(e) {
      // for whatever reason, sortablejs makes all children of element not draggable after a drag.
      // this messes up our internal image draggable - so here we manually alter the element attribute
      // for all images
      e.item.querySelectorAll('.editor-image').forEach((image) => {
        image.setAttribute('draggable', true)
      })
    }
  }

}
</script>

<style>

/* default has 2.5rem to accommodate delete, but if you don't have one it's a bit off-center */
.notification.notification-no-delete {
  padding-right: 1.5rem;
}

.tweetboxes-enter-active, .tweetboxes-leave-active {
  transition: all 0.1s;
}

.tweetboxes-move {
  transition: transform 0.1s;
}

.tweetboxes-enter, .tweetboxes-leave-to {
  opacity: 0;
  transform: translateX(100px);
}

.tweetboxes-enter {
  transform: translateX(-100px);
}

.tweetboxes-leave-to {
  transform: translateX(100px);
}

.fixed-side {
  position: -webkit-sticky;
  position: sticky;
  top: 66px;
}

.is-noscroll .fixed-side {
  position: inherit;
  top: auto;
}
</style>
